import { useEffect } from 'react';
import { useLocation } from 'react-router';
import urlJoin from 'url-join';
import { type EventApplicationEntrypointContextDataFragment } from '../../../api/fragments';
import { useRuntimeConfig } from '../../../runtimeConfig';

const insertScript = (dataScript, nonce) => {
    // Create a temporary DOM element to parse the script content
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = dataScript;

    // Extract script elements from the parsed content
    const scripts = tempDiv.getElementsByTagName('script');
    const noscripts = tempDiv.getElementsByTagName('noscript');
    const addedScripts = [];
    for (let i = 0; i < scripts.length; i++) {
        const script = document.createElement('script');
        if (scripts[i].src) {
            // If the script has a src attribute, set it
            script.src = scripts[i].src;
        } else {
            // Otherwise, set the inline script content
            script.innerHTML = scripts[i].innerHTML;
        }
        if (nonce) {
            script.setAttribute('nonce', nonce);
        }
        addedScripts.push(script);
        document.body.appendChild(script);
    }
    for (let i = 0; i < noscripts.length; i++) {
        const noscript = document.createElement('noscript');
        noscript.innerHTML = noscripts[i].innerHTML;
        addedScripts.push(noscript);
        document.body.appendChild(noscript);
    }

    return addedScripts;
};

const usePathScriptObserver = (endpoint: EventApplicationEntrypointContextDataFragment) => {
    const location = useLocation();
    const { router } = useRuntimeConfig();
    useEffect(() => {
        const pathScripts = endpoint.pathScripts.filter(
            pathScript => urlJoin(endpoint.pathname, pathScript.pathname) === location.pathname
        );
        let scripts = [];
        if (pathScripts.length) {
            // insert scripts
            scripts = pathScripts.flatMap(pathScript => insertScript(pathScript.script, router.nonce));
        }

        return () => {
            scripts.map(script => document.body.removeChild(script));
        };
    }, [location, endpoint, router.nonce]);
};

export default usePathScriptObserver;
